import React from 'react';
import Card from "@mui/material/Card";
import VisitResultClass from "./visitResultClass";
import {get} from 'lodash'
import { useRecordContext } from 'react-admin';
const ClassificationField = ({ source, record: recordProp, onDelete }) => {
  const recordFromContext = useRecordContext();
  const record = recordProp || recordFromContext;
    if (!record) {
        return null;
    }
    const value = get(record, source);
    if (value == null) {
        return null;
    }
    return (
        <Card style={{}}>
            <VisitResultClass category={value} />
        </Card>
    );
};

export default ClassificationField;
